const main_data = {
    slug_module: "categorias",
    key_interfaz: "categorias",
    key_esquema: "CATEGORIAS"
}

module.exports = {
    main_data
}